(() => {
  if (window.__giveawayEntryHandlerBound) return;
  window.__giveawayEntryHandlerBound = true;

  const FORM_SELECTOR = '[data-giveaway-form]';
  const STATUS_SELECTOR = '[data-giveaway-status]';

  const setStatus = (form, message, kind = '') => {
    const status = form.querySelector(STATUS_SELECTOR);
    if (!status) return;
    status.textContent = message;
    status.className = kind
      ? `giveaway-entry-form__status ${kind}`
      : 'giveaway-entry-form__status';
  };

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target.closest(FORM_SELECTOR) : null;
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const endpoint = form.dataset.endpoint;
      if (!endpoint) {
        setStatus(form, 'The form endpoint still needs to be configured before entries can be submitted.', 'is-error');
        return;
      }

      const formData = new FormData(form);
      if (formData.get('company')) {
        setStatus(form, 'Submission blocked.', 'is-error');
        return;
      }

      if (form.dataset.isSubmitting === '1') return;

      const submitButton = form.querySelector('button[type="submit"]');
      const payload = Object.fromEntries(formData.entries());
      payload.instagram_handle = String(payload.instagram_handle || '').trim();

      form.dataset.isSubmitting = '1';
      submitButton?.setAttribute('disabled', 'disabled');
      setStatus(form, 'Submitting your entry...');

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        let body = {};
        try {
          body = await response.json();
        } catch (_error) {
          body = {};
        }

        if (!response.ok) {
          throw new Error(body.error || 'Unable to submit your giveaway entry right now.');
        }

        form.reset();
        const redirectUrl = form.dataset.successRedirect;
        if (redirectUrl) {
          window.location.assign(redirectUrl);
          return;
        }

        const successHeading = form.dataset.successHeading || 'Entry received';
        const successBody = form.dataset.successBody || '';
        setStatus(form, successBody ? `${successHeading}. ${successBody}` : successHeading, 'is-success');
      } catch (error) {
        setStatus(
          form,
          error instanceof Error && error.message
            ? error.message
            : 'Unable to submit your giveaway entry right now.',
          'is-error'
        );
      } finally {
        delete form.dataset.isSubmitting;
        submitButton?.removeAttribute('disabled');
      }
    },
    true
  );
})();
